module.exports = __webpack_public_path__ + "img/fukuoka.cd728dc1.png";